export var typeSafeObjectEntries = function (obj) {
    return Object.entries(obj);
};
export var typeSafeObjectFromEntries = function (entries) { return Object.fromEntries(entries); };
export var camelToKebab = function (str) {
    return str.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase();
};
